import axios2 from "axios";
import React, { useCallback, useContext, useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/esm/Image";
import InputGroup from "react-bootstrap/esm/InputGroup";
import Modal from "react-bootstrap/esm/Modal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import EasyCropImage from "../components/EasyCropImage";
import { default as config } from "../config.json";
import useAxios from "../hooks/useAxios";
import getCroppedImg, { getError } from "../utils";
import LoadingBox from "./LoadingBox";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPLOAD_REQUEST":
      return { ...state, loadingUpload: true, errorUpload: "" };
    case "UPLOAD_SUCCESS":
      return {
        ...state,
        loadingUpload: false,
        errorUpload: "",
      };
    case "UPLOAD_FAIL":
      return { ...state, loadingUpload: false, errorUpload: action.payload };

    case "DELETE_FILE_REQUEST":
      return { ...state, dele: true, loadingDeletingImage: true };
    case "DELETE_FILE_SUCCESS":
      return {
        ...state,
        loadingDeletingImage: false,
      };
    case "DELETE_FILE_FAIL":
      return { ...state, loadingDeletingImage: false };

    default:
      return state;
  }
};

export default function Gorsel(props) {
  const axios = useAxios();
  const { image, setImage, entityId, entityName } = props;

  const [showCropImageModal, setShowCropImageModal] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const [{ loadingUpload, loadingDeletingImage }, dispatch] = useReducer(
    reducer,
    {
      loadingDeletingImage: false,
      loadingUpload: false,
    }
  );

  const { state } = useContext(Store);
  const { userInfo } = state;

  const getFileFromLocalFolder = (e) => {
    const file = e.target.files[0];
    setImage(URL.createObjectURL(file));
    setShowCropImageModal(true);
  };

  const uploadCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels, 0);
      setCroppedImage(croppedImage);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  const cancelCroppedImage = () => {
    setCroppedImage(null);
  };

  const uploadFileHandler = async (e) => {
    const file = await fetch(croppedImage)
      .then((r) => r.blob())
      .then(
        (blobFile) => new File([blobFile], "simplename", { type: "image/jpg" })
      );
    const bodyFormData = new FormData();
    bodyFormData.append("file", file);
    try {
      dispatch({ type: "UPLOAD_REQUEST" });
      const { data } =
        userInfo.isHelpDesk && !userInfo.client
          ? await axios2.post(
              `/api/upload/${entityId || "0"}?entityName=${entityName}`,
              bodyFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${userInfo.token}`,
                },
              }
            )
          : await axios.post(
              `/api/upload/${entityId || "0"}?entityName=${entityName}`,
              bodyFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
      dispatch({ type: "UPLOAD_SUCCESS" });

      toast.success("Görsel başarılı bir şekilde yuklendi");
      setImage(data.secure_url);
      setCroppedImage(null);
      setShowCropImageModal(false);
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPLOAD_FAIL", payload: getError(err) });
    }
  };

  const deleteFileHandler = async () => {
    try {
      dispatch({ type: "DELETE_FILE_REQUEST" });
      userInfo.isHelpDesk && !userInfo.client
        ? await axios2.delete(
            `/api/upload/${entityId || "0"}?entityName=${entityName}`,
            {
              headers: {
                Authorization: `Bearer ${userInfo.token}`,
              },
            }
          )
        : await axios.delete(
            `/api/upload/${entityId || "0"}?entityName=${entityName}`
          );
      dispatch({ type: "DELETE_FILE_SUCCESS" });

      setImage("");
      toast("Görsel başarılı bir şekilde silindi");
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "DELETE_FILE_FAIL", payload: getError(err) });
    }
  };

  return (
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Görsel</Form.Label>
        <div style={{ display: "flex" }}>
          <InputGroup>
            <label
              className="btn btn-outline-primary"
              htmlFor="upload"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Seç
            </label>
            <Form.Control
              disabled={true}
              value={image}
              onChange={(e) => setImage(e.target.value)}
            />
            <input
              id="upload"
              type="file"
              name="upload"
              className="form-control"
              style={{
                visibility: "hidden",
                maxWidth: "0px",
                padding: "0px",
              }}
              onChange={getFileFromLocalFolder}
            />
          </InputGroup>

          <>
            &nbsp;
            {image ? (
              <>
                &nbsp;&nbsp;
                <Link onClick={() => setShowCropImageModal(true)} to={""}>
                  <Image
                    fluid
                    rounded
                    src={image}
                    alt={"Yok"}
                    style={{ maxWidth: "40px" }}
                  ></Image>
                </Link>
                {image !== config.default_image && (
                  <Button
                    size="sm"
                    type="button"
                    variant="link"
                    className="textDecorationNone"
                    onClick={() => {
                      deleteFileHandler();
                    }}
                  >
                    <i className="fas fa-trash text-danger"></i>
                  </Button>
                )}
              </>
            ) : (
              <span className="text-danger">Görsel Seçilmedi!</span>
            )}
            <div>
              {(loadingUpload || loadingDeletingImage) && (
                <LoadingBox></LoadingBox>
              )}
            </div>
          </>
        </div>
      </Form.Group>

      <Modal
        size="lg"
        show={showCropImageModal}
        onHide={() => setShowCropImageModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ minHeight: "500px", maxHeight: "500px" }}>
          {image && (
            <EasyCropImage
              image={image}
              setCroppedAreaPixels={setCroppedAreaPixels}
              croppedImage={croppedImage}
            ></EasyCropImage>
          )}
        </Modal.Body>
        <Modal.Footer>
          {croppedImage ? (
            <div>
              {loadingUpload ? (
                <LoadingBox>Yukleniyor</LoadingBox>
              ) : (
                <>
                  <Button onClick={() => cancelCroppedImage()} variant="danger">
                    Iptal
                  </Button>
                  &nbsp;
                  <Button onClick={() => uploadFileHandler()} variant="success">
                    Tamam
                  </Button>
                </>
              )}
            </div>
          ) : (
            <Button onClick={() => uploadCroppedImage()} variant="danger">
              Devam Et
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}
